import { useEffect, useRef, useState, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Input } from '@artosera/ui';
import { useCreerLienFlux, type PlateformeDiffusion } from '../../api/diffusion.js';
import { Field } from '../Field.js';

export function LienFluxDialog({
  galerie,
  plateforme,
}: {
  galerie: string;
  plateforme: PlateformeDiffusion;
}): JSX.Element {
  const { t } = useTranslation(['regie', 'commun']);
  const creer = useCreerLienFlux(galerie, plateforme);
  const [ouvert, setOuvert] = useState(false);
  const [url, setUrl] = useState<string | null>(null);
  const [erreur, setErreur] = useState(false);
  const [copie, setCopie] = useState(false);
  const generation = useRef(0);
  useEffect(
    () => () => {
      generation.current += 1;
    },
    [],
  );
  const fermer = (valeur: boolean) => {
    if (!valeur) {
      generation.current += 1;
      setUrl(null);
      setErreur(false);
      setCopie(false);
    }
    setOuvert(valeur);
  };
  const demander = async () => {
    const essai = ++generation.current;
    setUrl(null);
    setErreur(false);
    setCopie(false);
    setOuvert(true);
    try {
      const resultat = await creer();
      if (generation.current === essai) setUrl(resultat.lien.url);
    } catch {
      if (generation.current === essai) setErreur(true);
    }
  };
  return (
    <>
      <Button variant="secondary" onClick={() => void demander()}>
        {t('regie:diffusion.lien.creer')}
      </Button>
      <Dialog
        open={ouvert}
        onOpenChange={fermer}
        title={t('regie:diffusion.lien.creer')}
        description={t('regie:diffusion.lien.unique')}
        closeLabel={t('commun:actions.fermer')}
      >
        {url ? (
          <>
            <Field htmlFor={`lien-${plateforme}`} label={t('regie:diffusion.lien.champ')}>
              <Input id={`lien-${plateforme}`} readOnly value={url} autoComplete="off" />
            </Field>
            <Button
              variant="secondary"
              onClick={() => {
                void navigator.clipboard
                  .writeText(url)
                  .then(() => setCopie(true))
                  .catch(() => setErreur(true));
              }}
            >
              {t('regie:diffusion.lien.copier')}
            </Button>
            {copie ? <p role="status">{t('regie:diffusion.lien.copie')}</p> : null}
          </>
        ) : !erreur ? (
          <p role="status">{t('commun:chargement')}</p>
        ) : null}
        {erreur ? <p role="alert">{t('commun:erreurReseau')}</p> : null}
      </Dialog>
    </>
  );
}
